import React from "react"

export type PrimitiveImageProps = React.ImgHTMLAttributes<HTMLImageElement> & {
	sx?: object
}

export const PrimitiveImage = ({ sx, ...props }: PrimitiveImageProps) => {
	return <img style={{ ...(sx as React.CSSProperties) }} {...props} />
}
